/**
 * Юридический документ целиком (C3).
 *
 * Тексты живут в базе с версиями: человек вправе увидеть ту редакцию, которую
 * принимал, а не только текущую.
 */
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from '../components/ui/Card';
import { PageHeader } from '../components/ui/PageHeader';
import { Markdown } from '../components/legal/Markdown';
import { authApi } from '../api/auth';

export function LegalPage() {
  const { t, i18n } = useTranslation();
  const { type } = useParams();
  const locale = i18n.resolvedLanguage ?? 'en';

  const document = useQuery({
    queryKey: ['consent-document', type, locale],
    queryFn: () => authApi.consentDocumentText(type!, locale),
    enabled: Boolean(type),
    staleTime: 5 * 60_000,
    retry: false,
  });

  return (
    <div className="mx-auto flex min-h-full max-w-[720px] flex-col gap-6 px-5 py-12">
      <PageHeader
        title={document.data?.title ?? t('legal.document')}
        {...(document.data
          ? { description: t('legal.version', { value: document.data.version }) }
          : {})}
      />
      <Card>
        <CardBody className="flex flex-col gap-4 text-body text-content-secondary">
          {document.isPending ? (
            <p className="text-content-muted">{t('common.loading')}</p>
          ) : document.data ? (
            <>
              {/* Язык может отличаться от интерфейса: перевода документа
                  может не быть, и молчать об этом нельзя — человек решит,
                  что сайт сломался. */}
              {document.data.locale !== locale.split('-')[0] && (
                <p className="text-meta text-content-muted">
                  {t('legal.otherLanguage', { locale: document.data.locale.toUpperCase() })}
                </p>
              )}
              <Markdown source={document.data.body} />
            </>
          ) : (
            <p>{t('legal.notFound')}</p>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
